import { FOLDER_TYPE } from "constants/documents";

export const getFileFolderShareLink = ({
  groupId,
  itemId,
  itemType,
}: {
  groupId: string;
  itemId: string;
  itemType: string;
}): string => {
  const sharePath = itemType === FOLDER_TYPE ? "docs" : "file-preview";

  return `${window.location.origin}/${sharePath}/${groupId}/${itemId}`;
};
